import { useSearchParams } from "react-router-dom";
import { resolveHomeHeroQuery } from "@/utils/homeHeroSession";

const useHomeHeroQuery = (): string => {
  const [searchParams] = useSearchParams();
  return resolveHomeHeroQuery(searchParams.get("hero"));
};

export default useHomeHeroQuery;
